import React from "react"
import { connect } from "react-redux"
import { Container } from "reactstrap"

import FeaturedMedia from "./headerFeaturedMedia"

function ShopHeader({ mobile, featuredMedia }) {
  return (
    <Container fluid className="shop-header">
      <h1 className="sr-only">RAD Shop</h1>
      <FeaturedMedia data={featuredMedia} mobile={mobile} />
    </Container>
  )
}

const mapStateToProps = state => ({
  mobile: state.global.mobile,
})

export default connect(mapStateToProps, {})(ShopHeader)
